import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react'

export const RunList = ({ jobId }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!jobId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('jobId', jobId));
  }, [jobId]);

  return (
    <EntityList entity="RUN" augRowsReq={augRowsReq}/>
  )
}
